import { Component } from '@angular/core';
import { soundpostGLAccountEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'GL Accounts') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostglaccount-form',
    templateUrl: './soundpostglaccount.form.component.html'
})
export class soundpostGLAccountFormComponent extends BaseFormComponent {
    public record!: soundpostGLAccountEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'reportOutputAgreementGLActivitySummaries', sectionName: 'Report Output Agreement GL Activity Summaries', isExpanded: false },
            { sectionKey: 'trialBalances', sectionName: 'Trial Balances', isExpanded: false },
            { sectionKey: 'gLAccountMappings', sectionName: 'GL Account Mappings', isExpanded: false },
            { sectionKey: 'reconFlowSnapshots', sectionName: 'Recon Flow Snapshots', isExpanded: false },
            { sectionKey: 'reportOutputAccountActivitySummaries', sectionName: 'Report Output Account Activity Summaries', isExpanded: false },
            { sectionKey: 'productGLAccounts', sectionName: 'Product GL Accounts', isExpanded: false },
            { sectionKey: 'reconBalanceSnapshots', sectionName: 'Recon Balance Snapshots', isExpanded: false },
            { sectionKey: 'reportOutputProductGLActivitySummaries', sectionName: 'Report Output Product GL Activity Summaries', isExpanded: false },
            { sectionKey: 'accountingEntryLines', sectionName: 'Accounting Entry Lines', isExpanded: false },
            { sectionKey: 'accountingAllocationRules', sectionName: 'Accounting Allocation Rules', isExpanded: false },
            { sectionKey: 'postingGroupLines', sectionName: 'Posting Group Lines', isExpanded: false }
        ]);
    }
}

